import {WindowParam, WindowParamContext} from "../../../library/context/WindowContext";
import {RowUnit} from "../../../library/atomic/unit/RowUnit";
import {SizeAttr} from "../../../library/basic/size";
import {ColumnUnit} from "../../../library/atomic/unit/ColumnUnit";
import {SpanText} from "../../../library/atomic/text/SpanText";
import {FontAttr} from "../../../library/basic/font";
import {BoxAttr, ColumnAttr, RowAttr} from "../../../library/basic/compose";
import {BoxUnit, widthGap} from "../../../library/atomic/unit/BoxUnit";
import {SpanHoverText} from "../../../library/atomic/text/SpanHoverText";
import {ImageUnit} from "../../../library/atomic/image/ImageUnit";
import {
    getOfficialHorizontalMargin,
    getOfficialInnerColWidth,
    getTopNavHeight,
    isSizeRangePcOrPcFull,
    isSizeRangePhone
} from "../compose/sizeRange";
import menuIcon from "../../../assets/official/menu.svg";
import closeIcon from "../../../assets/official/top-nav-close.svg";
import {downloadTrigger} from "../compose/officeLinkUtil";
import {Component} from "react";
import {CustomUnitProps} from "../../../library/atomic/unit/UnitProps";

export type TopNavProps = CustomUnitProps & {
    showBrowserHint: () => void
}

export class TopNav extends Component<TopNavProps> {
    static contextType = WindowParamContext;

    state: {
        isExpand: boolean
    } = {
        isExpand: false
    }

    render() {
        return (
            <WindowParamContext.Consumer>
                {wpt => {
                    let wp = wpt.param;
                    let innerColWidth = getOfficialInnerColWidth(wp)
                    let horizontalMargin = getOfficialHorizontalMargin(wp)

                    return (
                        <ColumnUnit
                            key={"CoralPlanets-OfficePage-TopNav-" + this.state.isExpand}
                            customStyleAttr={{
                                "background": "white",
                                "position": "fixed",
                                "top": "0",
                                "zIndex": "5000"
                            }}
                            sizeAttr={new SizeAttr(wp, "100vw", this.state.isExpand ? wp.currHeight + "px" : getTopNavHeight(wp))}>
                            <RowUnit
                                sizeAttr={new SizeAttr(wp, "100vw", getTopNavHeight(wp))}
                                customStyleAttr={{
                                    "boxShadow": "0 2px 4px rgba(106, 113, 112, 0.15)"
                                }}>
                                <RowUnit sizeAttr={new SizeAttr(wp, innerColWidth, getTopNavHeight(wp))}
                                         customStyleAttr={ColumnAttr.getChildrenPositionObj()}
                                >
                                    <ColumnUnit customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(),
                                        {"marginLeft": horizontalMargin})}>
                                        <SpanText
                                            fontAttr={new FontAttr(wp, "27.2px", "600", "\"YouSheShaYuFeiTeJianKangTi\"")}
                                            customStyleAttr={{"letterspacing": "1.5px"}}
                                        >
                                            信风Flow
                                        </SpanText>
                                    </ColumnUnit>

                                    {/*<BoxUnit*/}
                                    {/*    needHover={true}*/}
                                    {/*    sizeAttr={new SizeAttr(wp, isSizeRangePhone(wp) ? "92px" : "112px", isSizeRangePhone(wp) ? "28px" : "36px")}*/}
                                    {/*    customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(), {*/}
                                    {/*        "marginLeft": "auto",*/}
                                    {/*        "borderRadius": "12px",*/}
                                    {/*        "border": "1px solid black"*/}
                                    {/*    })}*/}
                                    {/*    onClick={() => {*/}
                                    {/*        // downloadTrigger(this.props.showBrowserHint)*/}
                                    {/*    }}*/}
                                    {/*>*/}
                                    {/*    <SpanText*/}
                                    {/*        fontAttr={new FontAttr(wp, isSizeRangePhone(wp) ? "13px" : "16px", "600", "\"Songti SC\"")}*/}
                                    {/*        customStyleAttr={Object.assign(BoxAttr.getChildrenPositionObj(), {"letterSpacing": "0.3px"})}*/}
                                    {/*    >*/}
                                    {/*        {"敬请期待"}*/}
                                    {/*    </SpanText>*/}
                                    {/*</BoxUnit>*/}

                                    {
                                        !isSizeRangePcOrPcFull(wp) &&
                                        <ImageUnit
                                            onClick={() => {
                                                this.setState(prevState => (Object.assign(prevState,
                                                    {
                                                        "isExpand": !this.state.isExpand
                                                    })))
                                            }}
                                            customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(), {
                                                "marginLeft": "24px"
                                            })}
                                            sizeAttr={new SizeAttr(wp, "30px", "30px")}
                                            url={this.state.isExpand ? closeIcon : menuIcon}/>
                                    }

                                    {widthGap(wp, horizontalMargin)}

                                </RowUnit>
                            </RowUnit>

                            {
                                this.state.isExpand &&
                                <ColumnUnit sizeAttr={new SizeAttr(wp, "100vw")}>
                                    {/*{NavMenuItem(wp, "大学生社区", "/")}*/}
                                    {/*{NavMenuItem(wp, "珊瑚同学AI", "/coralreef/ai/compose", true)}*/}
                                    {NavMenuItem(wp, "用户协议", "/useragreement")}
                                    {NavMenuItem(wp, "隐私政策", "/privacypolicy")}
                                </ColumnUnit>
                            }
                        </ColumnUnit>
                    )
                }
                }
            </WindowParamContext.Consumer>
        )
    }
}


function NavItem(wp: WindowParam, text: string, path: string, useOpen: boolean = false) {
    return (
        <SpanHoverText fontAttr={new FontAttr(wp, "18px", "600", "\"Songti SC\"")}
                       customStyleAttr={{"letterSpacing": "0.3px"}}
                       onClick={() => {
                           if (path != "") {
                               if (path == window.location.pathname) return
                               if (useOpen) {
                                   window.open(path, "_blank")
                               } else {
                                   window.location.href = path
                               }
                           }
                       }}
        >
            {text}
        </SpanHoverText>
    )
}

function NavMenuItem(wp: WindowParam, text: string, path: string, useOpen: boolean = false,
                     useSepLine: boolean = true) {
    return (
        <ColumnUnit sizeAttr={new SizeAttr(wp, "100vw")}>
            <RowUnit
                needHover={true}
                onClick={() => {
                    if (path != "") {
                        if (useOpen) {
                            window.open(path, "_blank")
                        } else {
                            window.location.href = path
                        }
                    }
                }}
                sizeAttr={new SizeAttr(wp, "100vw", "64px")}>
                <SpanText
                    fontAttr={new FontAttr(wp, "15px", "500", "\"SongTi SC\"")}
                    customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(), {
                        "marginLeft": getOfficialHorizontalMargin(wp),
                        "marginRight": "auto"
                    })}>
                    {text}
                </SpanText>
            </RowUnit>
            {
                useSepLine &&
                <BoxUnit
                    customStyleAttr={{"background": "#8a8a8d60"}}
                    sizeAttr={new SizeAttr(wp, "100vw", "1px")}/>
            }
        </ColumnUnit>
    )
}